import {AppFunction} from "../misc/types";
import View from "../framework/view";
import Server from "../server";
import reset_fail_template from "../../pugc/reset-fail";
import {ChangePasswordView} from "../views/change_password";

export class ChangePasswordFunction extends AppFunction {

    readonly v = new ChangePasswordView();

    view() {
        return this.v;
    }
    url() {
        return "/security/change-password";
    }
}

export class ResetPasswordFunction extends AppFunction {

    readonly v : View;

    userId: number | undefined;

    constructor(userId: number | undefined, isNew: boolean) {
        super();
        this.userId = userId;
        this.v = new ChangePasswordView(userId, true, isNew);
    }

    view() {
        return this.v;
    }
    url() {
        return "/security/reset-password" + (this.userId ? "/" + this.userId : "");
    }

    isRoot() {
        return true;
    }

    isZero() {
        return true;
    }

}


export class ResetFailFunction extends AppFunction {

    readonly v = new ResetFailView();

    view() {
        return this.v;
    }
    url() {
        return "/security/reset-fail";
    }

    isRoot() {
        return true;
    }

    isZero() {
        return true;
    }

}

class ResetFailView extends View {

    static classname = "reset-fail-view";

    private readonly server = Server.instance();

    constructor() {
        super(ResetFailView.classname);
    }

    protected render0(): JQuery<HTMLElement> {

        const template = reset_fail_template;

        const out = this.pug(template, {});
        return out;
    }

}
